import { AfterContentInit, Component, ContentChildren, ElementRef, Inject, Input, OnDestroy, QueryList, forwardRef } from "@angular/core";
import { Metric, MetricType, Thing } from "../../model";
import { AbstractThingContextService } from "../../shared/class/abstract-thing-context-service.class";
import { MetricDetailComponent } from "../../shared/component";
import { WidgetPrintResizeCoordinatorService } from "../shared/widget-print-resize-coordinator.service";

@Component({
    selector: 'wear-status-widget',
    template: require('./wear-status-widget.component.html')
})
export class WearStatusWidgetComponent implements AfterContentInit, OnDestroy {

    @Input() title: string;

    @ContentChildren(MetricDetailComponent) metricDetails: QueryList<MetricDetailComponent>;

    showWidget: boolean;
    wearMetrics: Metric[];
    thing: Thing;

    private _unregisterPrintResize: (() => void) | null = null;

    constructor(
        @Inject(forwardRef(() => AbstractThingContextService)) private thingContextService: AbstractThingContextService,
        @Inject(forwardRef(() => ElementRef)) private elementRef: ElementRef,
        @Inject(forwardRef(() => WidgetPrintResizeCoordinatorService)) private widgetPrintResizeCoordinator: WidgetPrintResizeCoordinatorService
    ) { }

    ngAfterContentInit(): void {
        this._unregisterPrintResize = this.widgetPrintResizeCoordinator.subscribeElement(this.elementRef);
        this.thing = this.thingContextService.getCurrentThing();
        if (this.thing && this.metricDetails?.length) {
            const metricNames: string[] = this.metricDetails.toArray().map(m => { return m.name });
            this.thingContextService.getMetrics().then(contextMetrics => {
                this.wearMetrics = this.validateMetrics(metricNames, contextMetrics);
                if (this.wearMetrics?.length) {
                    this.title = this.title || (this.wearMetrics.length > 1 ? 'Parts Wear' : this.wearMetrics[0].wornPart);
                    this.showWidget = true;
                }
            });
        }
    }

    ngOnDestroy(): void {
        this._unregisterPrintResize?.();
        this._unregisterPrintResize = null;
    }

    private validateMetrics(metricNames: string[], contextMetrics: Metric[]): Metric[] {
        let wearMetrics = [];
        metricNames.forEach(name => {
            const metric = contextMetrics.find(m => name == m.name && m.type == MetricType.WEAR);
            if (metric) {
                wearMetrics.push(metric);
            } else {
                console.error("Invalid metric " + name);
            }
        });
        return wearMetrics;
    }

}